<mat-toolbar color="warn" class="relative flex h-9">
  <!-- justify-between -->
  <div class="shrink-0">
    <span>[{{ stateName }}]</span>
  </div>
  @if (isDialog()) {
    <div class="absolute left-1/2 -translate-x-1/2 whitespace-nowrap">
      <span>{{ label() }}</span>
    </div>
  }
  <div class="ml-auto flex">
    @if (user1Visible()) {
      <button
        style="font-size: 12px; height: 28px; line-height: 28px"
        [class.btn-primary]="true"
        (click)="doUser1($event)"
      >
        {{ user1Text() }}
      </button>
    }
    @if (user2Visible()) {
      <button
        style="font-size: 12px; height: 28px; line-height: 28px"
        [class.btn-primary]="true"
        (click)="doUser2($event)"
      >
        {{ user2Text() }}
      </button>
    }
  </div>
  @if (isDialog()) {
    <div class="flex shrink-0 gap-1">
      @if (updateVisible) {
        <button
          style="font-size: 12px; height: 28px; line-height: 28px"
          [class.btn-editAndSave]="true"
          (click)="doEditAndSave($event)"
        >
          <mat-icon fontIcon="edit"></mat-icon>存檔
        </button>
      }
      <button
        style="font-size: 12px; height: 28px; line-height: 28px"
        [class.btn-primary]="true"
        cdkFocusInitial
        (click)="doOk($event)"
      >
        <!-- 🆗  --><mat-icon fontIcon="done"></mat-icon>確定
      </button>
      @if (cancelVisible()) {
        <button
          style="font-size: 12px; height: 28px; line-height: 28px"
          [class.btn-warning]="true"
          (click)="doCancel($event)"
        >
          <!--  ❌ --><mat-icon fontIcon="cancel"></mat-icon>取消
        </button>
      }
    </div>
  }
</mat-toolbar>
